import { TournamentStatus } from "model/Tournament/Tournament";
import { Option } from "./Option";
import { Tour } from "model/Tour/Tour";

interface Props {
  tour: Tour;
  status: TournamentStatus;
}

export const TourOption = ({ tour, status }: Props) => {
  return (
    <Option
      type="Tour"
      id={tour.id}
      status={status}
      endTime={tour.endTimeMs}
      startTime={tour.startTimeMs}
      name={tour.shortName}
      title={tour.name}
    />
  );
};
